export var PortalLoginSourceEnum;

(function (PortalLoginSourceEnum) {
  PortalLoginSourceEnum["Jove"] = "jove";
  PortalLoginSourceEnum["Broker"] = "broker";
  PortalLoginSourceEnum["Org"] = "org";
})(PortalLoginSourceEnum || (PortalLoginSourceEnum = {}));

export var PortalLoginSystemSourceEnum;

(function (PortalLoginSystemSourceEnum) {
  PortalLoginSystemSourceEnum["Cms"] = "cms";
  PortalLoginSystemSourceEnum["Dashboard"] = "dashboard";
  PortalLoginSystemSourceEnum["Website"] = "website";
})(PortalLoginSystemSourceEnum || (PortalLoginSystemSourceEnum = {}));

export var PortalLoginViewEnum;

(function (PortalLoginViewEnum) {
  PortalLoginViewEnum["Login"] = "login";
  PortalLoginViewEnum["SignUp"] = "signUp";
  PortalLoginViewEnum["ForgotPassword"] = "forgotPassword";
  PortalLoginViewEnum["ResetPassword"] = "resetPassword";
})(PortalLoginViewEnum || (PortalLoginViewEnum = {}));

export var PortalLoginHandleSourceEnum;
/** Auth session payload returned by the backend auth endpoints (password login / register / Google code exchange) */

(function (PortalLoginHandleSourceEnum) {
  PortalLoginHandleSourceEnum["ResetPassword"] = "reset-password";
  PortalLoginHandleSourceEnum["SignUp"] = "sign-up";
})(PortalLoginHandleSourceEnum || (PortalLoginHandleSourceEnum = {}));